import { render } from "./success.vue?vue&type=template&id=18e8fc1a&scoped=true&ts=true"
import script from "./success.vue?vue&type=script&lang=ts"
export * from "./success.vue?vue&type=script&lang=ts"

import "./success.vue?vue&type=style&index=0&id=18e8fc1a&scoped=true&lang=less"

import exportComponent from "/Users/user/Projects/simweb/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18e8fc1a"]])

export default __exports__